import { url } from "./api.url";

let preguntas = [];

const examQuestionsUrl = `${url}questions_exam`;
const answersByIdUrl = `${url}answers/`;

// Helper function to populate options
const populateOptions = (answers) => {
  return answers.map((answer) => ({
    textoRespuesta: answer?.Descripcion,
    isCorrect: answer?.Valida,
    questionId: answer?.PreguntaID,
    answerId: answer?.IDRespuesta,
  }));
};

// Fetch exam questions
const fetchData = async () => {
  try {
    const response = await fetch(examQuestionsUrl);
    return await response.json();
  } catch (error) {
    console.error("Error fetching exam questions:", error);
  }
};

// Fetch answers by question ID
const fetchResponseData = async (id) => {
  try {
    const res = await fetch(`${answersByIdUrl}${id}`);
    return await res.json();
  } catch (error) {
    console.error(`Error fetching answers for question ID ${id}:`, error);
  }
};

export const getQuestions = async () => {
  const preguntasRaw = await fetchData();
  const questionsPromises = preguntasRaw.map(async (preg, index) => {
    let pregunta = {
      id: index + 1,
      titulo: preg?.Descripcion,
    };

    if (preg?.RespuestaBooleana !== null) {
      // Handle boolean questions
      const optionsObj = [
        {
          textoRespuesta: "Verdadero",
          isCorrect: preg?.RespuestaBooleana,
          questionId: preg.IDPregunta,
        },
        {
          textoRespuesta: "Falso",
          isCorrect: !preg?.RespuestaBooleana,
          questionId: preg.IDPregunta,
        },
      ];
      pregunta.opciones = optionsObj;
    } else {
      // Handle multiple-choice questions
      const answers = await fetchResponseData(preg.IDPregunta);
      pregunta.opciones = populateOptions(answers);
    }

    return pregunta;
  });

  preguntas = await Promise.all(questionsPromises);
  return preguntas.slice(0, 20); // Limit to 20 questions
};
